import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Modal from "../Modal";
import { toastrApiErrors } from "../../utils/errors";

const DAYS = [
  { id: 0, day: "Sunday" },
  { id: 1, day: "Monday" },
  { id: 2, day: "Tuesday" },
  { id: 3, day: "Wednesday" },
  { id: 4, day: "Thursday" },
  { id: 5, day: "Friday" },
  { id: 6, day: "Saturday" }
];

const TOGGLE_OPTIONS = [
  { name: "Enabled", status: true },
  { name: "Disabled", status: false }
];

class ScheduleSettings extends React.Component {
  constructor(props) {
    super(props);

    const account = window.Application.currentAccount;

    this.state = {
      startDayOfWeek: account.start_day_of_week,
      availabilitiesToggle: account.availabilities_toggle,
      timeOffRequestToggle: account.time_off_requests_toggle,
      subRequestToggle: account.sub_requests_toggle,
      subRequestCutoff: account.sub_request_cutoff,
      autoCancelOpenSubRequest: account.auto_cancel_open_sub_request,
      autoCancelOpenSubRequestTime: account.auto_cancel_open_sub_request_time,
      autoApprovePendingSubRequest: account.auto_approve_pending_sub_request
    };
  }

  render() {
    const { visible, onClose } = this.props;
    const {
      startDayOfWeek,
      availabilitiesToggle,
      timeOffRequestToggle,
      subRequestToggle,
      subRequestCutoff,
      autoCancelOpenSubRequest,
      autoCancelOpenSubRequestTime,
      autoApprovePendingSubRequest
    } = this.state;

    return (
      <Modal title="Scheduling Settings" visible={visible} onClose={onClose}>
        <div>
          <label>Start Day of Week</label>
          <select
            className="form-control"
            title="Select Start Day"
            value={startDayOfWeek}
            onChange={this.handlerNumber("startDayOfWeek")}
          >
            {DAYS.map(item => (
              <option key={item.id} value={item.id}>
                {item.day}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Employee Availability</label>
          <select
            className="form-control"
            title="Select Employee Availability"
            value={availabilitiesToggle}
            onChange={this.handlerToggle("availabilitiesToggle")}
          >
            {TOGGLE_OPTIONS.map(item => (
              <option key={item.name} value={item.status}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Time Off Requests</label>
          <select
            className="form-control"
            title="Select Time Off Requests"
            value={timeOffRequestToggle}
            onChange={this.handlerToggle("timeOffRequestToggle")}
          >
            {TOGGLE_OPTIONS.map(item => (
              <option key={item.name} value={item.status}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Sub Requests</label>
          <select
            className="form-control"
            title="Select Sub Requests"
            value={subRequestToggle}
            onChange={this.handlerToggle("subRequestToggle")}
          >
            {TOGGLE_OPTIONS.map(item => (
              <option key={item.name} value={item.status}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Sub Request Cutoff (in hours)</label>
          <input
            type="number"
            title="Sub Req Cutoff"
            className="form-control"
            placeholder="24 hours"
            min="0"
            value={subRequestCutoff == null ? "" : subRequestCutoff}
            onChange={this.handlerNumber("subRequestCutoff")}
          />
        </div>

        <div>
          <label>Open Sub Request Auto-Cancel</label>
          <select
            title="Select Open Sub Request Auto-Cancel"
            className="form-control"
            value={autoCancelOpenSubRequest}
            onChange={this.handlerToggle("autoCancelOpenSubRequest")}
          >
            {TOGGLE_OPTIONS.map(item => (
              <option key={item.name} value={item.status}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>
            Open Sub Request Auto-Cancel Time (in hours)
          </label>
          <input
            type="number"
            title="Open Sub Request Auto-Cancel Time"
            className="form-control"
            placeholder="6 hours"
            min="0"
            value={
              autoCancelOpenSubRequestTime == null
                ? ""
                : autoCancelOpenSubRequestTime
            }
            onChange={this.handlerNumber("autoCancelOpenSubRequestTime")}
          />
        </div>

        <div>
          <label>Approve Sub Requests Automatically</label>
          <select
            title="Select Approve Sub Requests Automatically"
            className="form-control"
            value={autoApprovePendingSubRequest}
            onChange={this.handlerToggle("autoApprovePendingSubRequest")}
          >
            {TOGGLE_OPTIONS.map(item => (
              <option key={item.name} value={item.status}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-pink btn-raised btn-block pointer-hand"
            onClick={this.update}
          >
            UPDATE
          </button>
        </div>
      </Modal>
    );
  }

  handlerToggle = key => e =>
    this.setState({ [key]: e.target.value === "true" });

  handlerNumber = key => e => {
    const { value } = e.target;
    this.setState({ [key]: value === "" ? "" : Number(value) });
  };

  update = () => {
    const account = window.Application.currentAccount;
    const data = {
      account: {
        start_day_of_week: this.state.startDayOfWeek,
        availabilities_toggle: this.state.availabilitiesToggle,
        time_off_requests_toggle: this.state.timeOffRequestToggle,
        sub_requests_toggle: this.state.subRequestToggle,
        sub_request_cutoff: this.state.subRequestCutoff,
        auto_cancel_open_sub_request: this.state.autoCancelOpenSubRequest,
        auto_cancel_open_sub_request_time: this.state.autoCancelOpenSubRequestTime,
        auto_approve_pending_sub_request: this.state.autoApprovePendingSubRequest
      }
    };

    axios
      .put(`/accounts/${account.id}.json`, data)
      .then(() => {
        toastr.info("Schedule settings updated");
        setTimeout(() => window.location.reload(), 500);
      })
      .catch(error => {
        toastrApiErrors(error, "Unable to update schedule settings at this time");
      });
  };
}

ScheduleSettings.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func
};

export default ScheduleSettings;
